import React from 'react'
import SVGInline from 'react-svg-inline'
import ArrowRight from '../../assets/arrow-right.svg'
import './back-to-top.scss'

export default class BackToTop extends React.Component {
  constructor (props) {
    super(props)
    this.displayBackToTop = this.displayBackToTop.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.state = { active: false }
    this.screenMultiplier = 0.25
    this.isScrolling = null
    window.addEventListener('scroll', this.displayBackToTop, {passive: true})
  }

  displayBackToTop () {
    // Clear our timeout throughout the scroll
    window.clearTimeout(this.isScrolling)
    // Set a timeout to run after scrolling ends
    this.isScrolling = setTimeout(() => {
      this.screenCheck(window.pageYOffset, window.screen.availHeight, this.screenMultiplier)
    }, 150)
  }

  screenCheck (scrollCheck, screenHeight, multiplier) {
    var isActive = false
    isActive = scrollCheck > (screenHeight * multiplier)
    this.setState({ active: isActive })
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.displayBackToTop)
  }

  clickHandler () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  }

  render () {
    return <div className='back-to-top-container' onClick={this.clickHandler} style={{ opacity: this.state.active ? 1 : 0, visibility: this.state.active ? 'visible' : 'hidden' }}>
      <SVGInline svg={ArrowRight} />
    </div>
  }
}
